import request from '@/utils/request'

/**
 * @apiName 获取银行卡列表
 * @apiUrl
 */
export function getBankCardList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bankCard/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 银行卡状态变更
 * @apiUrl
 */
export function bankCardModifyState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bankCard/modifyState',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 银行卡预签约-第一步填写银行卡信息
 * @apiUrl
 */
export function bankCardPreSign(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bankCard/preSign',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 开户行列表
 * @apiUrl
 */
export function bankList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bank/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 银行卡预签约-第二步银行鉴权校验
 * @apiUrl
 */
export function bankCardSign(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bankCard/sign',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 网约签约平台查询
 */
export function queryRidePlatformList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/queryRidePlatformList',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 关联公司详情
 */
export function getCompanyWithholdDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/getCompanyWithholdDetail',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 关联公司保存
 */
export function saveCompanyWithhold(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/saveCompanyWithhold',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 发起线上签署
 */
export function walletWithholdOpen(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/walletWithhold/open',
    method: 'POST',
    data,
  })
}
